import * as amplitude from "@amplitude/analytics-browser";
import { useRequiredContext } from "@redotech/react-util/context";
import ChevronsDownIcon from "@redotech/redo-icons/chevron-down_filled.svg";
import { RedoAvatar } from "@redotech/redo-web/arbiter-components/avatar/redo-avatar";
import { TeamDataContext } from "@redotech/redo-web/navigation/common/team-switcher-data";
import { TeamSwitcherDropdown } from "@redotech/redo-web/navigation/common/team-switcher-dropdown";
import { memo, useState } from "react";
import { PlatformEvents } from "../../../platform-events";
import * as teamSwitcherCss from "./team-switcher.module.css";

interface TeamSwitcherProps {
  className?: string;
}

export const TeamSwitcher = memo(function TeamSwitcher({
  className,
}: TeamSwitcherProps) {
  const teamData = useRequiredContext(TeamDataContext);
  const { currentTeam, connectedStoresHaveTickets } = teamData;

  const [dropdownAnchor, setDropdownAnchor] = useState<HTMLElement | null>(
    null,
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <>
      <button
        className={`${teamSwitcherCss.teamSwitcherButton} ${className || ""}`}
        onClick={() => {
          if (!dropdownOpen) {
            amplitude.track(PlatformEvents.NAV_TEAM_SWITCHER_OPENED);
          }
          setDropdownOpen((old) => !old);
        }}
        ref={setDropdownAnchor}
        type="button"
      >
        <RedoAvatar
          content={{
            type: "image",
            imageUrl: currentTeam.logoUrl,
            altText: currentTeam.name,
            backup: { type: "text", text: currentTeam.name },
          }}
          size="xs"
          status={
            connectedStoresHaveTickets
              ? { type: "presence", color: "red" }
              : undefined
          }
        />
        <span className={teamSwitcherCss.teamName}>{currentTeam.name}</span>
        <ChevronsDownIcon className={teamSwitcherCss.chevronIcon} />
      </button>
      <TeamSwitcherDropdown
        dropdownAnchor={dropdownAnchor}
        dropdownOpen={dropdownOpen}
        hideZeroTicketBadge
        onTeamSelected={(teamId) =>
          amplitude.track(PlatformEvents.NAV_TEAM_SWITCHED, { teamId })
        }
        setDropdownOpen={setDropdownOpen}
        teamData={teamData}
      />
    </>
  );
});
